import React from 'react'
import Select from 'react-select'
import { get, some, every, isEmpty, filter, isPresent } from 'lodash'

const filteredData = ({ vcenters, filters }) => filter(vcenters, (vcenter) => {
  const filterResults = {}

  if (filters.locations != 'all') {
    filterResults['locations'] = some(filters.locations, location => location.value === get(vcenter, 'location_id'))
  }

  if (filters.customers != 'all') {
    filterResults['customers'] = some(filters.customers, customer => customer.value === get(vcenter, 'customer_name'))
  }

  return (every(filterResults, (value, _key) => value === true) || isEmpty(filterResults))
})

const VcenterReportFilters = ({ filters, changeFilters, filterOptions }) => (
  <div className="container-fluid" style={{ marginTop: '10px', marginBottom: '10px' }}>
    <div className='row'>
      <div className="col">
        Location
        <Select
          id='vcenterlocationFilter'
          isMulti
          value={filters.locations}
          options={filterOptions.locations}
          onChange={options => {
            let locations = options
            if (isEmpty(options)) { locations = 'all' }

            changeFilters({ ...filters, locations })
          }}
        />
      </div>

      <div className="col">
        Customer
        <Select
          id='vcenterCustomerFilter'
          isMulti
          value={filters.customers}
          options={filterOptions.customers}
          onChange={options => {
            let customers = options
            if (isEmpty(options)) { customers = 'all' }

            changeFilters({ ...filters, customers })
          }}
        />
      </div>
    </div>
  </div>
)

export { VcenterReportFilters, filteredData }
